import { tradingV2ControllerApi } from '../clients/clients';

const DEFAULT_POLL_INTERVAL = 300;
const DEFAULT_TIMEOUT = 20_000;

export type IntentStatus = {
  txnHash: string;
  success: boolean;
  reason: string;
};

export async function pollV2IntentStatus(
  intentHash: string,
  options?: {
    interval?: number;
    timeout?: number;
    timeoutMessage?: string;
  },
): Promise<IntentStatus> {
  const interval = options?.interval ?? DEFAULT_POLL_INTERVAL;
  const timeout = options?.timeout ?? DEFAULT_TIMEOUT;
  const timeoutMessage =
    options?.timeoutMessage ?? 'Timed out waiting for one-click V2 execution';

  const deadline = Date.now() + timeout;

  while (Date.now() < deadline) {
    const status = await tradingV2ControllerApi.getIntentStatus({
      intentHash,
    });

    if (!status.executed && !status.skipped) {
      await wait(interval);
      continue;
    }

    return {
      txnHash: status.txnHash,
      success: status.success === true || status.submitted === true,
      reason: status.reason || status.skipReason || '',
    };
  }

  throw new Error(timeoutMessage);
}

function wait(ms: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });
}
